import { render } from "./appears_on.vue?vue&type=template&id=3c68b04e"
import script from "./appears_on.vue?vue&type=script&lang=js"
export * from "./appears_on.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/appears_on.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c68b04e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c68b04e', __exports__)) {
    api.reload('3c68b04e', __exports__)
  }
  
  module.hot.accept("./appears_on.vue?vue&type=template&id=3c68b04e", () => {
    api.rerender('3c68b04e', render)
  })

}


export default __exports__